import React, { useState } from 'react'
import { NavLink } from "react-router-dom"
import Map from "../assets/helloCarMap.png"
import "./styles/contacts.css"

export default function Contacts() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    
      const [successMessage, setSuccessMessage] = useState('');
      const [errorMessage, setErrorMessage] = useState('');
      const place = "https://www.google.com/maps/place/Hello+Car/@28.5727509,77.2359505,17z/data=!3m1!4b1!4m6!3m5!1s0x390ce3ad0fffffff:0x2d142ceca0573859!8m2!3d28.5727462!4d77.2385254!16s%2Fg%2F1tl1lv54?entry=ttu"
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
    
        fetch('https://formspree.io/f/xyyrqagb', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message
          })
        }).then(response => {
          if (response.ok) {
            setSuccessMessage('Email sent successfully!');
            setErrorMessage('');
            setFormData({ name: '', email: '', subject: '', message: '' });
          } else {
            setSuccessMessage('');
            setErrorMessage('Failed to send email. Please try again.');
          }
        }).catch(error => {
          console.error('Error:', error);
          setSuccessMessage('');
          setErrorMessage('Failed to send email. Please try again.');
        });
      };
    
      return (
        <div className="Contacts">
          <header className="Contacts-header">
            <h1>Reach Out To Us!</h1>
          </header>
          <div className="contact-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>Send Us a Message</h2>
              <p>*Denotes Mandatory Fields</p>
              {successMessage && <p className="success-message">{successMessage}</p>}
              {errorMessage && <p className="error-message">{errorMessage}</p>}
              <div className="form-control">
                <label htmlFor="name">Name*</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-control">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-control">
                <label htmlFor="subject">Subject*</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-control">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
              <button type="submit">Submit</button>
            </form>
            <div className="contact-info">
              <div className="address">
                <NavLink to={place} target="_blank">
                    <h3>Our Address</h3>
                    <p>Hello Car<br />
                       B 77 Lajpat Nagar II<br />
                       Delhi 110024<br />
                       Working Hours : 10AM - 8PM {"(Timings may Slightly Differ)"}<br />
                       Mondays - Weekly Off {"(May Vary Accordingly)"}
                    </p>
                   <img className="contact-map" src={Map} alt="img"/>
                </NavLink>
              </div>
              <div className="social">
                <h3>Our Social</h3>
                <p>
                  <a href="https://www.instagram.com/update_n_upgrade/" target="_blank" rel="noopener noreferrer">Instagram  @update_n_upgrade</a><br />
                </p>
              </div>
              <div className="email">
                <h3>Email Us</h3>
                <p>For Product Questions/Concerns & General Inquiries: <a href="mailto:hellocarb77@gmail.com">hellocarb77@gmail.com</a></p>
              </div>
            </div>
          </div>
        </div>
      );
}